import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";

import GoogleMap from '../Map/Map';
import RestaurantIcon from '../../assets/img/map-icons/restaurant.svg';
import UserIcon from '../../assets/img/map-icons/user.svg';
import DriverIcon from '../../assets/img/map-icons/driver.svg';
import { getOrder, getBranchData, getAlert, getUserData, getFreeDrivers, getDriverData, getRestaurantData, changeAlertStatus, changeOrderStatus } from "../../store/actions";


const Cancelled = props => {
    if(!props.driver) return null;
    return (
        <div className="box">
            <div className="box-title canceled">
                <h3 className="w-500">Driver Cancelled The Order</h3>
            </div>

            <div className="box-body">
                <div className="flex">
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">Reason</p>
                                <p className="color-primary">{ props.alert.reason }</p>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Driver First Name</p>
                                <Link to="#" className="color-primary">{ props.driver.first_name }</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">Driver Last Name</p>
                                <Link to="#" className="color-primary">{ props.driver.last_name }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Mobile Number</p>
                                <Link to="#" className="color-primary">{ props.driver.mobile_number }</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="box-meta flex justify-end">
                <button className="btn filled primary min-120 small" onClick={props.changeAlertStatus}>Go Back</button>
            </div>
        </div>
    );
};

const Complains = props => {
    if(!props.user) return null;
    return (
        <div className="box">
            <div className="box-title complains">
                <h3 className="w-500">User Complains</h3>
            </div>

            <div className="box-body">
                <div className="flex">
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">User ID</p>
                                <Link to="#" className="color-primary">{ props.user.id }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Driver First Name</p>
                                <Link to="#" className="color-primary">{ props.user.first_name }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Driver Last Name</p>
                                <Link to="#" className="color-primary">{ props.user.last_name }</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">Order ID</p>
                                <Link to="#" className="color-primary">{ props.order}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Mobile Number</p>
                                <Link to="#" className="color-primary">{ props.user.mobile_number }</Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <ul className="w-700">
                    <li className="py-10">
                        <p className="font-sm color-grey50">Complaint Text</p>
                        <p className="color-primary mt-5">{ props.alert.complaint_text }</p>
                    </li>
                </ul>
            </div>
            <div className="box-meta flex justify-end">
                <button className="btn filled primary min-120 small" onClick={props.changeAlertStatus}>Go Back</button>
            </div>
        </div>
    );
};

const Duplication = props => {
    if(!props.user || !props.alert || !props.order) return null;
    return (
        <div className="box">
            <div className="box-title duplication">
                <h3 className="w-500">Order Duplication</h3>
            </div>

            <div className="box-body">
                <div className="flex">
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">Order ID-1</p>
                                <Link to="#"className="color-primary">{ props.order }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Order ID-2</p>
                                <Link to="#" className="color-primary">{ props.alert.duplicated_order }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User ID</p>
                                <Link to="#" className="color-primary">{props.user.id}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">User First Name</p>
                                <Link to="#" className="color-primary">{props.user.first_name}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User Last Name</p>
                                <Link to="#" className="color-primary">{props.user.last_name}</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="box-meta flex justify-end">
                <button className="no-style w-600 pointer mr-20 font-sm" onClick={props.changeAlertStatus} >Confirm the second order</button>
                <button className="btn filled primary min-220 small" onClick={() => props.changeOrderStatus(props.order)}>Cancel the second order</button>
            </div>
        </div>
    );
};

const Threshold = props => {
    if(!props.user || !props.alert) return null;
    return (
        <div className="box">
            <div className="box-title exceeds">
                <h3 className="w-500">Order Exceeds The Threshold</h3>
            </div>

            <div className="box-body">
                <div className="flex">
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">User ID</p>
                                <Link to="#" className="color-primary">{props.user.id}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Defined Threshold</p>
                                <p className="color-primary">{ props.alert.threshold } SAR</p>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Order Amount</p>
                                <p className="color-primary">{ props.alert.order_amount } SAR</p>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">User First Name</p>
                                <Link to="#" className="color-primary"> {props.user.first_name }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User Last Name</p>
                                <Link to="#" className="color-primary">{ props.user.last_name }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Mobile Number</p>
                                <Link to="#" className="color-primary">{props.user.mobile_number }</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="box-meta flex justify-end">
                <button className="no-style w-600 pointer mr-20 font-sm" onClick={props.changeAlertStatus}>Confirm the order</button>
                <button className="btn filled primary min-220 small" onClick={() => props.changeOrderStatus(props.order)}>Cancel the order</button>
            </div>
        </div>
    );
};

const NoDriver = props => {
    if(!props.user) return null;
    return (
        <div className="box">
            <div className="box-title no-driver">
                <h3 className="w-500">No Driver Accepts The Order</h3>
            </div>

            <div className="box-body">
                <div className="flex">
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">Order ID</p>
                                <Link to="#" className="color-primary">{ props.order }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User ID</p>
                                <Link to="#" className="color-primary">{ props.user.id }</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User First Name</p>
                                <Link to="#"  className="color-primary">{props.user.first_name}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">User Last Name</p>
                                <Link to="#"  className="color-primary">{props.user.last_name}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-xs-6">
                        <ul className="w-700">
                            <li className="py-10">
                                <p className="font-sm color-grey50">User Mobile Number</p>
                                <Link to="#" className="color-primary">{props.user.mobile_number}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Restaurant Name</p>
                                <Link to="#" className="color-primary">{props.restaurant.restaurant.name}</Link>
                            </li>
                            <li className="py-10">
                                <p className="font-sm color-grey50">Restaurant Address</p>
                                <p  className="color-primary">{props.restaurant.address}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="box-meta flex justify-end">
                <button className="btn filled primary min-120 small" onClick={props.changeAlertStatus}>Go Back</button>
            </div>
        </div>
    );
};

class Alert extends Component {

    componentDidMount() {
        const { id, order } = this.props.match.params;
        const alert = this.props.match.params.alert;
        this.props.getAlert(id).then(res => {
            if (alert === 'no_driver_accept_alerts') {
                this.props.getFreeDrivers(res.order);
                this.props.getOrder(order);
            }
            this.props.getRestaurant(res.branch_id);
            if(res[alert].driver) {
                this.props.getDriver(res[alert].driver);
            } else if (res[alert].user) {
                this.props.getUser(res[alert].user);
            }
        });
    }

    renderRateStars = rate => {
        if(!rate) {
            rate = 0;
        }
        const starts = [];
        for (let i = 0; i < 5; i++) {
            if (i < rate) {
                starts.push(<li key={i}><i className="fa fa-star"></i></li>);
            }else {
                starts.push(<li key={i}><i className="fa fa-star deactive"></i></li>);
            }
        }
        return starts;
    };

    changeAlertStatus = () => {
        const data = { status: 'finished' };
        this.props.changeAlertStatus(this.props.alert.id, data).then(res => {
            this.props.history.push('/operation-room/map');
        })
    };

    changeOrderStatus = (id) => {
        const data = { status: 'finished' };
        this.props.changeOrderStatus(id, { status: 'cancelled_by_admin' }).then(res => {
            this.props.changeAlertStatus(this.props.alert.id, data).then(res => {
                this.props.history.push('/operation-room/map');
            })
        });

    };

    render() {
        let alert = null;
        if ((this.props.user || this.props.driver) && this.props.alert && this.props.restaurant && this.props.order) {
            const alerts = {
                canceled_order_alerts: <Cancelled changeAlertStatus={ this.changeAlertStatus } alert={this.props.alert.canceled_order_alerts} user={this.props.user} driver={this.props.driver} order={this.props.alert.order}/>,
                user_complain_alerts: <Complains changeAlertStatus={ this.changeAlertStatus } alert={this.props.alert.user_complain_alerts} user={this.props.user} driver={this.props.driver} order={this.props.alert.order}/>,
                order_duplication_alerts: <Duplication changeOrderStatus={ this.changeOrderStatus } changeAlertStatus={ this.changeAlertStatus } alert={this.props.alert.order_duplication_alerts} user={this.props.user} driver={this.props.driver} order={this.props.alert.order}/>,
                exceed_threshold_alerts: <Threshold changeOrderStatus={ this.changeOrderStatus } changeAlertStatus={ this.changeAlertStatus } alert={this.props.alert.exceed_threshold_alerts} user={this.props.user} driver={this.props.driver} order={this.props.alert.order}/>,
                no_driver_accept_alerts: <NoDriver restaurant={this.props.restaurant} changeAlertStatus={ this.changeAlertStatus } alert={this.props.alert.no_driver_accept_alerts} user={this.props.user} driver={this.props.driver} order={this.props.alert.order}/>
            };
            alert = alerts[this.props.match.params.alert];
        }
        return (
            <React.Fragment>
                { <div className="map-wrapper full-width">
                    <div className="map">
                        {this.props.alert ? <GoogleMap order={this.props.alert.order}
                                                       alert
                                                       renderRateStars={this.renderRateStars}
                                                       history={this.props.history}
                                                       changeAlertStatus={ this.changeAlertStatus }
                                                       alertId={ this.props.alert.id }
                                                       freeDrivers={this.props.freeDrivers}
                                                       position={this.props.alert.restaurant_position} /> : null }

                        <ul className="map-icons">
                            <li>
                                <img src={ RestaurantIcon } alt="Restaurant icon"/>
                                <span>Restaurants</span>
                            </li>
                            <li>
                                <img src={ UserIcon } alt="User icon"/>
                                <span>User</span>
                            </li>
                            <li>
                                <img src={ DriverIcon } alt="Driver icon"/>
                                <span>Driver</span>
                            </li>
                        </ul>
                        { alert }
                    </div>
                </div>}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        alert: state.operations.alert,
        user: state.operations.user,
        driver: state.operations.driver,
        freeDrivers: state.customer.freeDrivers,
        restaurant: state.operations.restaurant,
        order: state.operations.restaurant,
        branch: state.operations.branch
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAlert: (id) => dispatch( getAlert(id) ),
        getUser: (id) => dispatch( getUserData(id) ),
        getDriver: (id) => dispatch( getDriverData(id) ),
        getRestaurant: (id) => dispatch( getRestaurantData(id) ),
        getBranchData: (id) => dispatch( getBranchData(id) ),
        getFreeDrivers: (id) => dispatch( getFreeDrivers(id) ),
        changeAlertStatus: (id, data) => dispatch( changeAlertStatus(id, data) ),
        changeOrderStatus: (id, data) => dispatch( changeOrderStatus(id, data) ),
        getOrder: (id) => dispatch( getOrder(id) ),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)( Alert );



// WEBPACK FOOTER //
// ./src/components/Operation-room/Alert.js